import React from "react";
import { useTranslation } from "react-i18next";

function ConfidentialDocsTab() {
  const { t } = useTranslation("generate");

  return (
    <div className="generate-form-container">
      <div className="generate-coming-soon">
        <div className="generate-coming-soon-icon"></div>
        <div className="generate-coming-soon-title">{t("confidentialDocs.comingSoon")}</div>
        <div className="generate-coming-soon-text">
          {t("confidentialDocs.comingSoonText")}
        </div>
      </div>
    </div>
  );
}

export default ConfidentialDocsTab;
